module.exports = __webpack_public_path__ + "static/img/logo.2b7b2945.png";